import { DataBean } from "../DataBean";

export class InvoiceTransportGuide extends DataBean {

    public async invoiceTransportGuide(idTransportGuide: any, transportGuideDate: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_invoiceTransportGuide_Number_java.util.Date_Number", [idTransportGuide, transportGuideDate, idEmployee]);
    }

}